<template>
  <div class="footer">
    <footer>
      <div class="footer-left">
        <div><img src="../assets/images/TPE_LOGO.png" alt="" style="max-width: 119px;" /></div>
        <ul>
          <li>
            <span
              ><img src="../assets/images/bottom_contact1_icon.png" alt=""
            /></span>
            <span class="bottomSpan">（上環總店）聯繫方式 : (852) 3462 6432</span>
          </li>
          <li>
            <span
              ><img src="../assets/images/bottom_contact4_icon.png" alt=""
            /></span>
            <span class="bottomSpan">傳真(FAX) : (852) 34604910 </span>
          </li>
          <li>
            <span
              ><img src="../assets/images/bottom_contact3_icon.png" alt=""
            /></span>
            <span class="bottomSpan"
              >（上環總店）地址(ADDRESS) : 上環德輔道中254號金融商業大廈地下A舖
            </span>
          </li>
        </ul>
        <div class="link" style="display:none">
          <div class="link-c">
            <ul>
              <li>友情連接：</li>
              <li>
                <a href="http://www.dhwaibi.com/" target="_blank">兑换外币</a>
              </li>
              <!-- <li><a href="http://www.gdhfqp.com" target="_blank">广州月嫂培训</a></li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <ul>
          <li @click="serviceMove" style="cursor: pointer;">我們的服務</li>
          <li @click="goInformation" style="cursor: pointer;">兌換資訊</li>
          <li @click="findMove" style="cursor: pointer;">聯繫我們</li>
        </ul>
      </div>
      <div class="footer-bottom">
        Copyright ©2019誠通找換外幣兌換 siteMap
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    serviceMove() {
      this.navigateToSection("service");
    },
    findMove() {
      this.navigateToSection("find");
    },
    goInformation() {
      const targetPath = "/information/";
      if (this.$route && this.$route.path === targetPath) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      this.$router.push({ path: targetPath }).catch(() => {});
    },
    navigateToSection(section) {
      const selector = section === "find" ? ".find" : ".service";
      if (this.$route && this.$route.path === "/") {
        this.$nextTick(() => {
          this.scrollToSection(selector);
        });
        return;
      }
      // 非首页时跳转首页，由首页路由逻辑处理锚点滚动
      this.$router.push({ path: "/", query: { section } }).catch(() => {});
    },
    scrollToSection(selector) {
      const target = document.querySelector(selector);
      if (!target) return;
      const navEl = document.querySelector(".nav");
      const navHeight = navEl ? navEl.getBoundingClientRect().height : 0;
      console.log(navHeight, 'navHeight');
      const top = target.getBoundingClientRect().top + window.scrollY - navHeight;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    },
  },
  components: {}
};
</script>
<style scoped>
@import "../common/font/font.css";
.footer {
  background-image: url("../assets/images/bottom_bg.png");
  background-size: 100% 100%;
  width: 100%;
  height: 410px;
}
.footer footer {
  width: 75%;
  height: 100%;
  margin: auto;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 20px 0px;
  box-sizing: border-box;
}
.footer footer > div:nth-child(1) {
  flex: 0 0 45%;
}
.footer footer > div:nth-child(2) {
  flex: 0 0 45%;
}
.footer footer > div:nth-child(3) {
  flex: 0 0 100%;
}
/* .footer-left,.footer-right{
  float: left;
  margin: 50px 0 0 0;
} */
.footer-right {
  font-family: Regular;
  color: white;
}
.footer-left {
  width: 50%;
  box-sizing: border-box;
  padding: 0 40px;
}
.footer-right {
  width: 50%;
}
.footer-left li {
  margin: 20px 0;
  color: white;
  font-family: Regular;
}
.footer-right li {
  display: inline-block;
  padding: 0 20px;
  font-size: 16px;
}
.bottomSpan {
  padding: 0 10px;
}
.footer-bottom {
  width: 100%;
  color: white;
  position: absolute;
  bottom: 10px;
  text-align: center;
  font-family: Regular;
}
.footer-left .link-c li {
  display: inline;
  color: #97969596;
  font-family: Regular;
}
.footer-left .link-c li a {
  color: #97969596;
  font-family: Regular;
  font-size: 14px;
}
@media (max-width: 890px) {
  .footer {
    margin: 0 0 10px 0;
    padding-bottom: 40px;
  }
  .footer footer {
    width: 100%;
  }
  .footer-left,
  .footer-right {
    margin: 10px 0 0 0;
  }
  .footer-left {
    padding: 0;
  }
  .footer-right li {
    font-size: 12px;
  }
  .footer .link li {
    font-size: 12px;
  }
}
@media (max-width: 650px) {
  .footer footer > div:nth-child(1) {
    flex: 0 0 100%;
    padding: 0 20px;
  }
  .footer footer > div:nth-child(2) {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
  .footer {
    height: auto;
  }
}
</style>
